function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useState } from 'react';
import Types from 'prop-types';
import { useIntl } from 'react-intl';
import { Avatar, Image, Drawer, Position, Select, Button } from '@transferwise/components';
import { Globe, FastFlag } from '@transferwise/icons';
import { ThemeProvider, useTheme } from '@wise/components-theming';
import { LocaleValues } from '../../../../../../common/l10n';
import AVAILABLE_FLAGS from './availableFlags.json';
import normaliseLanguage from '../../../../../../common/utils/normaliseLanugage';
var getCountryFlag = function getCountryFlag(code) {
  if (!code) return /*#__PURE__*/React.createElement(Globe, {
    className: "tw-public-nav__country-selector__icon"
  });
  return AVAILABLE_FLAGS.includes(code) ? /*#__PURE__*/React.createElement(Avatar, {
    size: "sm",
    type: "thumbnail"
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: "https://wise.com/web-art/assets/flags/".concat(code, ".svg")
  })) : /*#__PURE__*/React.createElement(FastFlag, {
    className: "tw-public-nav__country-selector__icon"
  });
};
export var CountryLanguageSelector = function CountryLanguageSelector(_ref) {
  var language = _ref.language,
    availableLanguages = _ref.availableLanguages,
    onLanguageChange = _ref.onLanguageChange,
    locale = _ref.locale,
    availableLocales = _ref.availableLocales,
    onLocaleChange = _ref.onLocaleChange;
  var fallbackLocales = [locale ? {} : {
    value: '',
    label: 'Worldwide'
  }];
  var locales = availableLocales || fallbackLocales;
  var localeSelectOptions = locales.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      icon: /*#__PURE__*/React.createElement("span", null, getCountryFlag(item.value))
    });
  });
  var alphabeticallySortedLocaleSelectOptions = localeSelectOptions.sort(function (a, b) {
    return a.label.localeCompare(b.label, normaliseLanguage(language));
  });
  var _useState = useState(localeSelectOptions.find(function (l) {
      return l.value === locale;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    selectedLocale = _useState2[0],
    setSelectedLocale = _useState2[1];
  var languages = availableLanguages || [{
    value: language,
    label: language
  }];
  var languageLabel = language.substring(0, 2).toUpperCase();
  var languageSelectOptions = languages.map(function (_ref2) {
    var _Intl;
    var value = _ref2.value;
    var langCode = value.replace('_', '-');
    var langName = (_Intl = Intl) !== null && _Intl !== void 0 && _Intl.DisplayNames ? new Intl.DisplayNames([langCode], {
      type: 'language'
    }).of(langCode) : langCode;
    return {
      value: value,
      label: /*#__PURE__*/React.createElement("span", {
        className: "tw-public-nav__language",
        lang: langCode
      }, langName)
    };
  });
  var _useState3 = useState(languageSelectOptions.find(function (l) {
      return l.value === language;
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedLanguage = _useState4[0],
    setSelectedLanguage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    drawerIsOpen = _useState6[0],
    setDrawerIsOpen = _useState6[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var languageChanged = (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.value) !== language;
  var localeChanged = (selectedLocale === null || selectedLocale === void 0 ? void 0 : selectedLocale.value) !== locale;
  var isReadOnly = locales.length < 2 && languages.length < 2;
  var handleSubmit = function handleSubmit() {
    setDrawerIsOpen(false);
    if (languageChanged) onLanguageChange(selectedLanguage);
    if (localeChanged) onLocaleChange(selectedLocale);
  };
  var handleDrawerClose = function handleDrawerClose() {
    setDrawerIsOpen(false);
  };
  var _useTheme = useTheme(),
    isModern = _useTheme.isModern;
  return /*#__PURE__*/React.createElement("li", {
    className: "tw-public-nav__item"
  }, isReadOnly ? /*#__PURE__*/React.createElement("div", {
    className: "tw-link-with-chevron tw-link-read-only"
  }, getCountryFlag(locale), /*#__PURE__*/React.createElement("span", {
    className: "tw-public-nav__menu-item-text text-ellipsis"
  }, languageLabel)) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "tw-link-with-chevron",
    onClick: function onClick() {
      setDrawerIsOpen(!drawerIsOpen);
    }
  }, getCountryFlag(locale), /*#__PURE__*/React.createElement("span", {
    className: "tw-public-nav__menu-item-text text-ellipsis"
  }, languageLabel)), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: isModern ? 'personal' : 'light',
    screenMode: "light"
  }, /*#__PURE__*/React.createElement(Drawer, {
    open: drawerIsOpen,
    position: Position.RIGHT,
    headerTitle: formatMessage({
      id: 'public-navigation.country-language-selector'
    }),
    footerContent: /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: handleSubmit,
      block: true
    }, formatMessage({
      id: 'public-navigation.country-language-selector.submit-btn'
    })),
    onClose: handleDrawerClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-a-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "control-label mw-body-1",
    htmlFor: "language-selector"
  }, formatMessage({
    id: 'public-navigation.language.selector.label'
  })), /*#__PURE__*/React.createElement(Select, {
    id: "language-selector",
    size: "md",
    dropdownRight: "xs",
    dropdownWidth: "lg",
    block: true,
    disabled: languages.length < 2,
    selected: selectedLanguage,
    onChange: function onChange(v) {
      return setSelectedLanguage(v);
    },
    options: languageSelectOptions
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "control-label mw-body-1",
    htmlFor: "locale-selector"
  }, formatMessage({
    id: 'public-navigation.country.selector.label'
  })), /*#__PURE__*/React.createElement(Select, {
    id: "locale-selector",
    size: "md",
    dropdownRight: "xs",
    dropdownWidth: "lg",
    block: true,
    disabled: locales.length < 2,
    selected: selectedLocale,
    onChange: function onChange(v) {
      return setSelectedLocale(v);
    },
    search: true,
    searchPlaceholder: formatMessage({
      id: 'public-navigation.country.selector.label'
    }),
    options: alphabeticallySortedLocaleSelectOptions
  })))))));
};
CountryLanguageSelector.defaultProps = {
  availableLanguages: null,
  availableLocales: null,
  onLanguageChange: function onLanguageChange() {},
  onLocaleChange: function onLocaleChange() {},
  locale: ''
};